module.exports = __webpack_public_path__ + "img/3.4467078e.png";